<script>
import { toasterMethods, voaFiservReportMethods } from '@state/helpers'
import constant from '@constants/constant'

export default {
  data() {
    return {
      showSpinner: false,
      waitText: 'Getting widgets ready',
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getOrderID()

    if (localStorage.getItem('fiservThanksDisplayed') === '1') {
      localStorage.removeItem('fiservThanksDisplayed')
    }
    if (localStorage.getItem('voaFiservThanksReload') === 'true') {
      localStorage.removeItem('voaFiservThanksReload')
    }
    if (localStorage.getItem('orderId') !== '') {
      localStorage.removeItem('orderId')
    }
  },
  methods: {
    ...voaFiservReportMethods,
    ...toasterMethods,
    async getOrderID() {
      let responseGuid
      try {
        this.showSpinner = true
        responseGuid = await this.voaFiservNoOtpGuid({
          guid: this.$route.params.guid,
        })
        if (responseGuid.data && responseGuid.data.responseStatus === 1) {
          let signonResp
          try {
            signonResp = await this.fetchSignonInfo(responseGuid.data.id)
            if (
              signonResp.data.message !== null ||
              signonResp.data.message !== ''
            ) {
              this.showSpinner = false
              localStorage.setItem('orderId', responseGuid.data.id)

              this.$router.push({
                name: 'fiservWidgets',
                params: {
                  fiservSessionId: signonResp.data.message,
                  domainName: signonResp.data.externalId,
                  orderId: responseGuid.data.id,
                },
              })
            }
          } catch (er) {
            this.showSpinner = false
            this.authError = er
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
          }
        } else if (responseGuid.data) {
          this.showSpinner = false
          this.waitText = 'Link is Expired'
          this.setAlert({
            title: constant.imageHeaderError,
            msg: 'Link is Expired',
            variant: constant.errorMessagetype,
          })
        }
      } catch (e) {
        this.showSpinner = false
        this.authError = e
        this.setAlert({
          title: constant.imageHeaderError,
          msg: constant.errorMessage,
          variant: constant.errorMessagetype,
        })
      }
    },
  },
}
</script>
<template>
  <div>
    <p :class="$style.widgetsText"> {{ waitText }} </p>
    <BaseSpinner v-show="showSpinner" />
  </div>
</template>
<style lang="scss" module>
@import '@design';
.widgetsText {
  margin-top: 60px;
  font-size: 30px;
  text-align: center;
}
</style>
